export default {
  statistics: {
    // Stats are now business keyed. This is here just for refference.
    // open: {
    //   all: 0,
    //   unassigned: 0,
    //   all_unread: 0,
    //   unassigned_unread: 0,
    //   user_assigned: {},
    //   user_unread: {},
    // },
    // done: {
    //   all: 0,
    //   unassigned: 0,
    //   user_assigned: [],
    // },
    // spam: {
    //   all: 0,
    //   unassigned: 0,
    //   user_assigned: [],
    // },
    // seen: 0,
    // new: 0,
    // unassigned: 0,
    // user_assigned: [],
    // all: 0,
  },
  addConversationActivity: {},
  removeConversationActivity: {},
  conversationList: [],
  allConversationsList: [],
  activeConversation: {},
  messageList: {
    data: [],
    meta: {},
  },
  quickReplyList: [],
  unreadConversationsCount: {},
  reassignedConversation: {},
  sentMessageStatus: {},
  conversationsLoad: {
    loaded: false,
    loading: false,
    page: 1,
  },
  messagesLoaded: false,
  messagesLoading: false,
  messageSent: false,
  conversationSeen: false,
  botStatusUpdated: false,
  quickRepliesLoaded: false,
  quickReplyCreated: false,
  quickReplyUpdated: false,
  quickReplyDeleted: false,
  folderChanged: false,
  apiError: {},
  fileUploadError: {},
  /** Object holds up to 30 latest messages for each chat to be loaded instantly. NOTE: move to cache store on rewrite. */
  chatFastReload: {},
  // NOTE: move to cache store on rewrite.
  /** Keeps track of the 1st page of conversations so there is no need for refreshing when switching between numbers or folders. Keys are number IDs or keyword 'My' representing list that needs to go into 'My chats' section. */
  conversationFastReload: {},
  chatSearchAllNumbersSelected: false,
  // used just to trigger the wather and update the messageList because watcher is not working for nested data.
  messageCountChange: 0,
  startNewConversationSelectId: null,
  startConversationNumber: null,
  /** Holds tempConversations until they are canceled or conversation has been started and they are no longer temp conversations. */
  tempConversations: [],
  allowEnter: false,
  enterPressed: 0,
  folder: 'open',
  showEmptyDone: false,
  showEmptyOpen: false,
  showEmptyFresh: false,
  forceConversationLoadSpinner: false,
  resetConversationListFlag: false,
  reloadFirstPage: 0,
  inputMessageText: null,
  addMessage: {},
  removeMessage: {},
  botStateChange: null,
  updateConversation: {},
  updateConversations: {
    businessId: null,
    conversations: [],
  },
  /** Stores unsent message on conversation changes so when a user returns to a chat there is already text in the input waiting to be edited or sent. */
  inputBackup: {},
  pusherEmojiReactionReceived: null,
  /** Unread conversations counter per number. Initial counter is set from statistic endpoint and then updated via pusher. */
  unreadCounter: {},
};
